export const SLIDES_TO_SHOW = Object.freeze({ SM: 2.3, MD: 3, LG: 4 })
